export const CUSTOM_CONFIG = {
    "NEW_MEDIA_MANAGE": {
        "SHOW_MAIN_DEPT": null,
        "SELECT_LIST_FUN": function (that) {
            return []
        }
    }
}